import { Form } from 'react-final-form'
import { FormattedMessage, useIntl, defineMessage } from 'react-intl'
import { getCookie, isValidEmail, setCookie } from '../../../utils'
import FormInput from '../../forms/final-form-fields/FormInput'
import styles from './OptInPopup.module.scss'
import { useEffect, useState } from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'
import api from '../../../api'

export default function OptInPopup({ language }) {
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    if(getCookie('optInEmail') === 'true') {
      setIsOpen(false)
    }
  }, [])

  const validate = (values) => {
    const errors = {}

    if(!values.email) {
      errors.email = true
    } else if(!isValidEmail(values.email)) {
      errors.email = true
    }

    return errors
  }

  const onSubmit = async (values) => {
    const data = {
      email: values.email,
      source: 'Travel|Email Capture Popup|Popup',
      preferenceIds: [100, 1001003, 1001035],
    }
    try {
      await api('/api/recipients/').post(data)
      setIsOpen(false)
      setCookie('optInEmail', 'true')
    } catch (e) {
      console.error(e)
      setCookie('optInEmail', 'false')
    } finally {
      setIsOpen(false)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  if(!isOpen) {
    return null
  }

  return (
    <div className={styles.container}>
      <i
        className={cx('font-icons close-icon', styles.closeButton)}
        onClick={handleClose}
      />
      <img
        src={`${window.staticPath}travel_dist/images/opt-in-promo.webp`}
        alt={formatMessage(
          defineMessage({ defaultMessage: 'Scuba Vacation Checklist' }),
        )}
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <h2 className={styles.heading}>
          <FormattedMessage defaultMessage='Join the Community & Get Our Scuba Vacation Checklist' />
        </h2>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({ handleSubmit, submitting, pristine }) => (
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.inputWrapper}>
                <FormInput
                  name='email'
                  type='email'
                  placeholder={formatMessage(
                    defineMessage({ defaultMessage: 'Email Address' }),
                  )}
                  className={styles.emailInput}
                />
              </div>
              <button type='submit' className={styles.button}>
                <FormattedMessage defaultMessage='Get Your Free PDF' />
              </button>
              <p className={styles.disclaimer}>
                <FormattedMessage
                  defaultMessage='By subscribing you confirm you are at least 16 years old and agree to receive communication, offers, and information from PADI. <a>Click here</a> to visit our Privacy Policy.'
                  values={{
                    a: (chunks) => (
                      <a
                        href='https://www.padi.com/privacy'
                        className={styles.link}
                      >
                        {chunks}
                      </a>
                    ),
                  }}
                />
              </p>
            </form>
          )}
        />
      </div>
    </div>
  )
}

OptInPopup.propTypes = {
  language: PropTypes.string.isRequired,
}
